export const SET_TOKEN_RECAPTCHA = "TBEXTERNO_REDESIM_SET_TOKEN_RECAPTCHA";
export const SET_RECAPTCHA_RESET_REF = "TBEXTERNO_SET_RECAPTCHA_RESET_REF";
export const TOGGLE_MODAL_SOLICITAR_BAIXA_MEI = "TBEXTERNO_REDESIM_TOGGLE_MODAL_SOLICITAR_BAIXA_MEI";
export const SET_SOLICITAR_BAIXA_MEI = "TBEXTERNO_SET_SOLICITAR_BAIXA_MEI";
export const PESQUISAR_SOLICITAR_BAIXA_MEI = "TBEXTERNO_PESQUISAR_SOLICITAR_BAIXA_MEI";
export const SOLICITAR_BAIXA_MEI_SELECIONAR = "TBEXTERNO_SOLICITAR_BAIXA_MEI_SELECIONAR";
export const SOLICITAR_BAIXA_MEI_CONFIRMAR_SENHA = "TBEXTERNO_SOLICITAR_BAIXA_MEI_CONFIRMAR_SENHA";
export const SOLICITAR_BAIXA_MEI_PROCESSAR = "TBEXTERNO_SOLICITAR_BAIXA_MEI_PROCESSAR";
